import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/subscriptions/:subscriptionId/cancel`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const cancel = {
  post: apiPathFunc(pathBase),
};
